import {
  formatISOTimestampsInText,
  formatTimelineTimestamp,
  getHistoryTimelineDotClass,
  getHistorySourceIcon,
  getHistoryTimelineTitle,
  getHistorySourceBadge,
} from "../utils/formatters";

export default function TicketHistoryTimeline({ history }) {
  return (
    <div className="border rounded-2xl overflow-hidden bg-white">
      <div className="bg-gray-50 px-4 py-3 text-sm font-semibold border-b">
        Ticket History
      </div>
      <div className="p-4">
        {!history || history.length === 0 ? (
          <div className="text-sm text-gray-500 text-center py-8">
            No history recorded yet.
          </div>
        ) : (
          <div className="pl-1">
            {history.map((entry, idx) => {
              const actionText = entry.action_taken || entry.action || "";
              const dotClass = getHistoryTimelineDotClass(actionText);
              const icon = getHistorySourceIcon(entry.agent_name);
              const title = getHistoryTimelineTitle(actionText);
              const badge = getHistorySourceBadge(entry.agent_name);
              const agentLabel = entry.agent_name ? `by ${entry.agent_name}` : "—";
              const isLast = idx === history.length - 1;
              return (
                <div
                  key={entry.history_id || entry.id || idx}
                  className="flex gap-4 items-stretch"
                >
                  <div className="flex flex-col items-center w-11 shrink-0">
                    <div
                      className={`relative z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-white text-sm shadow-sm ring-2 ring-gray-100 ${dotClass}`}
                      title={entry.agent_name || ""}
                    >
                      <span className="leading-none" aria-hidden>{icon}</span>
                    </div>
                    {!isLast ? (
                      <div className="mt-0 w-0.5 flex-1 min-h-[1.25rem] bg-gray-200" />
                    ) : null}
                  </div>
                  <div className={`min-w-0 flex-1 ${isLast ? "" : "pb-8"}`}>
                    <div className="flex flex-wrap items-center gap-2 gap-y-1">
                      <span className="text-sm font-bold text-gray-900">{title}</span>
                      <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${badge.className}`}>
                        {badge.label}
                      </span>
                    </div>
                    <div className="mt-1 text-xs text-gray-600">{agentLabel}</div>
                    {actionText ? (
                      <p className="mt-2 text-sm text-gray-500 whitespace-pre-wrap break-words">
                        {formatISOTimestampsInText(actionText)}
                      </p>
                    ) : null}
                    {(entry.query || entry.customer_query) && (
                      <p className="mt-2 text-sm text-gray-500">
                        <span className="font-semibold text-gray-600">Query: </span>
                        {entry.query || entry.customer_query}
                      </p>
                    )}
                    {(entry.solution || entry.response) && (
                      <p className="mt-2 text-sm text-gray-500">
                        <span className="font-semibold text-gray-600">Solution: </span>
                        {entry.solution || entry.response}
                      </p>
                    )}
                    <div className="mt-3 text-right text-xs text-gray-400">
                      {formatTimelineTimestamp(entry.created_at || entry.timestamp)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
